var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.53 24H2.47A2.48 2.48 0 0 1 0 21.53V5.4a2.48 2.48 0 0 1 2.47-2.47h19.06A2.48 2.48 0 0 1 24 5.4v16.13A2.48 2.48 0 0 1 21.53 24M2.47 4.93A.47.47 0 0 0 2 5.4v16.13a.47.47 0 0 0 .47.47h19.06a.47.47 0 0 0 .47-.47V5.4a.47.47 0 0 0-.47-.47z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23 10.8H1a1 1 0 0 1 0-2h22a1 1 0 1 1 0 2M6.87 7.13a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v5.13a1 1 0 0 1-1 1m10.26 0a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v5.13a1 1 0 0 1-1 1"
})));
export default SvgCalendar;